var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "raft-js-base-filters"
  }, [_c('fieldset', {
    staticClass: "raft-js-base-filters-fieldset"
  }, [_c('b-form', [_vm.isBusy ? _c('raft-busy', {
    attrs: {
      "is-raft-styling": false,
      "data-test": "filters-busy",
      "busy-text": "Loading filters..."
    }
  }) : _vm._l(_vm.filtersDivided, function (rowFilterData, index) {
    return _c('filter-row', {
      key: index,
      attrs: {
        "cols-per-row": _vm.colsPerRow,
        "filters": rowFilterData
      },
      on: {
        "update-filters": _vm.updateFilters
      }
    });
  })], 2)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }